import { Box, Button } from "@mui/material";
import React from "react";
import { transparentButtonStyleWhitefont } from "../../../shared/styles/buttonStyles";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from "react-i18next";
import { useWindowSize } from "../../../shared/hooks/useWindowSize";

export default function BackButton() {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Box className="workshop-list-top-bar-title">
            <Button
                // variant="contained"
                sx={{...transparentButtonStyleWhitefont, color: "white"}}
                color="primary"
                onClick={() => navigate(location.state?.from || "/")}
                startIcon={ <ArrowBackIcon /> }
            >
                {t("actions.back")}
            </Button>
        </Box>
    )
}